import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Woman2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"woman_2"}/>
}
